import * as React from 'react';

import { Form } from '@longline/aqua-ui/containers/Form';
import { Input } from '@longline/aqua-ui/inputs/Input';
import { Selector } from '@longline/aqua-ui/inputs/Selector';
import { CountryDropdown } from '@longline/aqua-ui/modules/CountryDropdown'
import { DivisionDropdown } from '@longline/aqua-ui/modules/DivisionDropdown'

import { ISystem } from '../../api/models/ISystem';
import { Pane } from '../../ui/Pane';
import { Grid } from '../../ui/Grid';

interface IProps {
  system: ISystem;
  onChange: (profile: ISystem, forceUpdate: boolean) => void;
  onValidate: (valid: boolean) => void;
  /** 
   * Are all form controls currently disabled? This would be done while
   * saving is going on.
   */
  disabled?: boolean;
  dirty?: boolean;
}

const SystemForm = (props: IProps) =>
  <Form
    data={props.system}
    onChange={props.onChange}
    onValidate={props.onValidate}
    dirty={props.dirty}
  >
    <Grid>
      <Grid.Item weight={6}>
        <Form.Field 
          rules={{
            required:  { message: "System name is required." },
            minLength: { length: 3, message: "System name must be at least 3 characters."},
            maxLength: { length: 42, message: "System name must be at most 42 characters."}
          }}
          name="name" label="name"
          value={props.system.name}
          disabled={props.disabled}
          wrapper='box'
          control={<Input transparent type="text" placeholder="System's name" fluid/>}
          hint={<>The system's <b>name</b>.</>}
        />
      </Grid.Item>
      <Grid.Item weight={6}>
        <Form.Field 
          rules={{
            required: { message: "Country is required." },
          }}
          name="country" label="Country"
          value={props.system.country}
          wrapper='box'
          forceupdate
          disabled={props.disabled}
          control={<CountryDropdown clearable/>}
          hint={<>The system's <b>country</b>.</>}
        />
      </Grid.Item>
      <Grid.Item weight={6}>
        <Form.Field 
          name="division" label="Administrative division"
          value={props.system.division}
          wrapper='box'
          forceupdate
          disabled={!props.system.country || props.disabled}
          control={<DivisionDropdown clearable fluid country={props.system.country ?? ""}/>}
          hint={<>The system's <b>administrative division</b>.</>}
        />
      </Grid.Item>
    </Grid>        
  </Form>

export { SystemForm }
